var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 0C11.7181 0 11.4893 0.22875 11.4893 0.510656C11.4893 0.792516 11.7181 1.02131 12 1.02131C18.0536 1.02131 22.9787 5.94642 22.9787 12C22.9787 18.0537 18.0536 22.9787 12 22.9787C5.94638 22.9787 1.02127 18.0536 1.02127 12C1.02127 11.7181 0.792516 11.4893 0.510609 11.4893C0.22875 11.4893 0 11.7181 0 12C0 18.6168 5.38317 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38317 18.6168 0 12 0Z","fill":"#1F2937","key":0}),React.createElement("path",{"d":"M11.9999 3.82983C11.718 3.82983 11.4892 4.05858 11.4892 4.34049V11.4894H6.89347C6.61161 11.4894 6.38281 11.7182 6.38281 12.0001C6.38281 12.282 6.61156 12.5108 6.89347 12.5108H11.9999C12.2818 12.5108 12.5106 12.282 12.5106 12.0001V4.34049C12.5106 4.05858 12.2818 3.82983 11.9999 3.82983Z","fill":"#1F2937","key":1})]);
}

Clock.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
